import React from "react";
import "./style/button.scss";
import { Button } from "react-bootstrap";
import { useStrings } from "../../../hooks/useStrings";

interface BackButtonProps {
  onBack: () => void;
  dataTestId?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  onBack,
  dataTestId = "backButton",
}) => {
  const S = useStrings();
  return (
    <Button
      className="btn btn-back"
      onClick={onBack}
      id="backButton"
      data-testid={dataTestId}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="5 2 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginRight: "5px" }}
      >
        <path d="m15 18-6-6 6-6"></path>
      </svg>
      {S.COMMON.BACK}
    </Button>
  );
};
